<template>
  <div qaid="project-one-toolbar" class="project-one-toolbar">
    <trek-button
      v-for="panel in panels"
      :key="panel.qaid"
      v-tippy="{placement: 'right'}"
      :qaid="panel.qaid"
      :icon="panel.icon"
      icon-only
      tertiary
      :class="[
        toolbarDrawer.currentDrawerTab === panel.name
          ? 'project-one-toolbar__btn--active'
          : 'project-one-toolbar__btn--inactive',
        {'project-one-toolbar__btn--dormant': !toolbarDrawer.currentDrawerTab},
      ]"
      :title="panel.title"
      @click="updateToolbarTab(panel.name)"
    />
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import TrekButton from '@/components/TrekButton';
export default {
  components: {TrekButton},
  computed: {
    panels() {
      let panels = [
        {
          qaid: 'toolbar-btn-print-sell-sheet',
          icon: 'insert_drive_file',
          title: this.bp('toolbarPrintSellSheet'),
          name: 'ProjectOneToolbarPrintSellSheet',
          isShownForWarranty: true,
        },
        {
          qaid: 'toolbar-btn-price-lead-time',
          icon: 'attach_money',
          title: this.bp('toolbarPriceLeadTime'),
          name: 'ProjectOneToolbarPriceLeadTime',
          isShownForWarranty: true,
        },
        {
          qaid: 'toolbar-btn-customer-info',
          icon: 'person',
          title: this.bp('toolbarCustomerInfo'),
          name: 'ProjectOneToolbarCustomerInfo',
          isShownForWarranty: false,
        },
        {
          qaid: 'toolbar-btn-sizing',
          icon: 'accessibility',
          title: this.bp('toolbarSizing'),
          name: 'ProjectOneToolbarSizing',
          isShownForWarranty: true,
        },
        {
          qaid: 'toolbar-btn-spec',
          icon: 'list',
          title: this.bp('toolbarSpec'),
          name: 'ProjectOneToolbarSpec',
          isShownForWarranty: true,
        },
      ];
      if (this.bikeData.packageType === 'WarrantyFrameset') {
        panels = panels.filter((p) => p.isShownForWarranty);
      }
      return panels;
    },
    ...mapState('projectOne', ['toolbarDrawer', 'bikeData']),
  },
  methods: {
    updateToolbarTab(tabSelected) {
      this.toolbarDrawer.currentDrawerTab === tabSelected
        ? this.setDrawerCurrentTabAndOpenState(null)
        : this.setDrawerCurrentTabAndOpenState(tabSelected);
    },

    ...mapActions('projectOne', ['setDrawerCurrentTabAndOpenState']),
  },
};
</script>
<style lang="scss" scoped>
.project-one-toolbar {
  @apply flex;
  @apply flex-col;
  @apply px-25;
  @apply py-4;
  @apply shadow-lg;
  @apply z-30;

  &__btn {
    &--inactive {
      @apply text-gray-40;
    }

    &--active,
    &--dormant {
      @apply text-gray-100;
    }
  }
}
</style>
